import { Author } from "@customTypes/Author";
import { createContext, ReactNode, useContext } from "react";

export interface BSRContentPageContextProps {
  authorsHeading?: string;
  authorsList?: Author[];
}

interface BSRContentPageProviderProps {
  children: ReactNode;
  details: BSRContentPageContextProps;
}

export const BSRContentPageContext = createContext<BSRContentPageContextProps>(
  {}
);

export const BSRContentPageProvider = ({
  children,
  details,
}: BSRContentPageProviderProps) => {
  const { authorsHeading, authorsList } = details;

  return (
    <BSRContentPageContext.Provider
      value={{
        authorsHeading,
        authorsList,
      }}
    >
      {children}
    </BSRContentPageContext.Provider>
  );
};

export const useBSRContentPages = () => useContext(BSRContentPageContext);

export const bsrContextMock = {
  authorsHeading: "Author Heading Test",
  authorsList: [
    {
      uid: "e2b0ec43-12f1-4334-adf7-f0b6af4423d5",
      component: "articleAuthors",
      fields: {
        articleAuthorFacultyProfile: null,
        articleAuthorContributorProfile: {
          fields: {
            slug: "think/contributors/sophie-haydock",
            profilePositionTitle: "testing position title",
            profilePhoto: {
              uid: "1618ADyFVSghASScYEvvmr",
              fields: {
                title: "SophieHaydock 512x386",
                description: "",
                file: {
                  url: "//images.london.edu/hxo16fanegqh/1618ADyFVSghASScYEvvmr/709c4bc81968f8a99269faf05daff602/SophieHaydock-512x386.jpg",
                  details: { size: 147168, image: { width: 512, height: 386 } },
                  fileName: "SophieHaydock-512x386.jpg",
                  contentType: "image/jpeg",
                },
              },
            },
          },
        },
        articleAuthorName: "Sophie Haydock",
      },
    },
    {
      uid: "a14b48e7-480f-4522-a854-dae3edf532f1",
      component: "articleAuthors",
      fields: {
        articleAuthorFacultyProfile: {
          fields: {
            slug: "faculty-and-research/faculty-profiles/i/ioannou-i",
            authorName: "Ioannis Ioannou",
            profilePositionTitle:
              "Associate Professor of Strategy and Entrepreneurship",
            profilePhoto: {
              uid: "16f5ce7f-a00e-4a33-9fb1-e459ebb232c7-asset",
              fields: {
                title: "Ioannis Ioannou large",
                description: "Ioannis Ioannou large",
                file: {
                  url: "//images.london.edu/hxo16fanegqh/16f5ce7f-a00e-4a33-9fb1-e459ebb232c7-asset/4777359a39149711f6104f24734b3a66/SB-Ioannis-527x347.png",
                  details: { size: 314600, image: { width: 527, height: 347 } },
                  fileName: "SB-Ioannis-527x347.png",
                  contentType: "image/png",
                },
              },
            },
          },
        },
        articleAuthorContributorProfile: null,
        articleAuthorName: "Ioannis Ioannou",
      },
    },

    {
      uid: "902f8ce5-c2f8-41f4-a0c7-86a9f814594b",
      component: "articleAuthors",
      fields: {
        articleAuthorFacultyProfile: null,
        articleAuthorContributorProfile: null,
        articleAuthorName: "Pawel Stach",
      },
    },
  ],
};
